import { AppMenuNavOption } from '@data-access/shared';
import { AI_IRB_ADMIN_LINKS } from '../constants';

// Keep in step with ai-irb's APP_ADMIN_LINKS and group gating.

// Okta group names suffixed with deployment environment.
export function oktaGroupsFor(env: string) {
  return {
    ERM_BUSINESS_ADMIN: `App-ERM-Business-Admin-${env}`,
    ERM_IT_ADMIN: `App-ERM-IT-Admin-${env}`,
    ERM_MANAGER: `App-ERM-Manager-${env}`,
    ERM_INTERNAL: `App-ERM-Internal-${env}`,
  } as const;
}

// Empty when joBaseUrl is empty (documented opt-out).
export function buildAiIrbAdminLinks(
  userGroups: readonly string[],
  env: string,
  joBaseUrl: string,
): AppMenuNavOption[] {
  if (!joBaseUrl) return [];

  const g = oktaGroupsFor(env);
  const gates = {
    admin: [g.ERM_BUSINESS_ADMIN, g.ERM_IT_ADMIN],
    internal: [
      g.ERM_INTERNAL,
      g.ERM_MANAGER,
      g.ERM_BUSINESS_ADMIN,
      g.ERM_IT_ADMIN,
    ],
  };

  return AI_IRB_ADMIN_LINKS.filter((link) =>
    gates[link.gate].some((allowed) => userGroups.includes(allowed)),
  ).map((link) => ({
    label: link.label,
    route: `${joBaseUrl}${link.path}`,
    external: true,
  }));
}
